import React from 'react';

const SummaryDetails = ({ subtotal, discount }) => {
    return (
        <div className="summary-details">
            {/* Subtotal Row */}
            <div className="d-flex justify-content-between mb-3">
                <span className="text-muted">Subtotal</span>
                <span className="fw-semibold">
                    Rs. {subtotal?.toLocaleString() || '0'}
                </span>
            </div>

            {/* Discount Row - Conditional Rendering */}
            {discount > 0 && (
                <div className="d-flex justify-content-between mb-3 text-success">
                    <div className="d-flex align-items-center">
                        <i className="bi bi-tag-fill me-2 small"></i>
                        <span>Discount</span>
                    </div>
                    <span className="fw-semibold">
                        - Rs. {discount.toLocaleString()}
                    </span>
                </div>
            )}

            {/* Shipping Row - Placeholder for UX completeness */}
            <div className="d-flex justify-content-between mb-3">
                <span className="text-muted">Estimated Shipping</span>
                <span className="text-success fw-medium small text-uppercase">Free</span>
            </div>

            {/* Tax Row */}
            <div className="d-flex justify-content-between mb-1">
                <span className="text-muted">Estimated Tax</span>
                <span className="fw-semibold">Rs. 0</span>
            </div>
        </div>
    );
};

export default SummaryDetails;